import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CollapseListModule } from '../../../../../components/collapse-list/collapse-list.module';
import { CollapseItem } from '../../../../../components/collapse-list/model/collapse.model';
import { DemoCollapseItemComponent } from './demo-collapse-item/demo-collapse-item.component';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { CmsComponent, CmsService } from '@spartacus/core';

@Component({
  selector: 'demo-collapse-list',
  standalone: true,
  imports: [CommonModule, CollapseListModule],
  templateUrl: './demo-collapse-list.component.html',
  styleUrl: './demo-collapse-list.component.scss',
})
export class DemoCollapseListComponent implements OnInit, OnDestroy {
  collapseList$ = new BehaviorSubject<CollapseItem[]>([
    {
      id: '1',
      title: 'First Item',
      isOpen: false,
      content: 'Content: <strong>I`m just a string</strong>',
    },

    {
      id: '2',
      title: 'Secound Item',
      isOpen: false,
      component: DemoCollapseItemComponent,
      data: {
        term: 'Hello, World!',
      },
    },
  ]);

  subscription = new Subscription();

  constructor(private cmsService: CmsService) {}

  ngOnInit(): void {
    this.getFlexComponent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getFlexComponent() {
    this.subscription.add(
      this.cmsService
        .getComponentData('HomeVideoBannerCarousel')
        .pipe(take(1))
        .subscribe((component: CmsComponent | null) => {
          if (component) {
            this.collapseList$.next([
              ...this.collapseList$.getValue(),
              ...[
                {
                  id: component.uid || '',
                  title: 'Third Item',
                  content: '<p class="m-b-20">Content: <strong>I`m a flexComponent called by uID</strong></p>',
                  cxComponent: component,
                  hostClass: component.styleClasses || '',
                  isOpen: false,
                },
              ],
            ]);
          }
        }),
    );
  }
}
